import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';

@Component({
  selector: 'app-wallet-payment-dialog',
  templateUrl: './wallet-payment-dialog.component.html',
  styleUrls: ['./wallet-payment-dialog.component.scss']
})
export class WalletPaymentDialogComponent implements OnInit {
  cardPinInput = new FormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<WalletPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private panelService: PanelService,
    private googleTagManagerService: GoogleTagManagerService
  ) {}

  ngOnInit(): void {}

  submitForm() {
    if (!this.cardPinInput.valid) {
      return;
    }

    this.panelService
      .ChargeWalletHiPinPayment(this.data?.order?.id, {
        pin: this.cardPinInput.value
      })
      .subscribe((res) => {
        let analyticData = {
          amount: this.data?.order?.amount,
          transaction_id: this?.data?.order?.transaction_id,
          currency: this.data?.order?.currency_detail?.code,
          gateway: this.data?.title,
          gateway_id: this.data?.order?.gateway_detail?.id,
          gateway_type: this.data?.order?.gateway_detail?.gateway_type
        };

        this.googleTagManagerService.sendAnalytics('charge_wallet', {
          ...analyticData
        });
        this.dialogRef.close({
          success: true
        });
      });
  }
}
